<div class="charts">
  <div class="charts__pie">
    <canvas #chartCanvas aria-label="Pie Chart" role="img"></canvas>
  </div>
</div>
